<script lang="ts">
	export let content: string;
</script>

<div class="content">
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html content}
</div>

<style>
	.content {
		& p {
			font-weight: 400;
			font-size: 1.125rem;
			line-height: 1.75rem;
			margin-bottom: 1rem;
		}
		& ul {
			font-size: 1.125rem;
			line-height: 1.75rem;
			margin-bottom: 1rem;
			list-style: disc inside;
		}
		& ol {
			font-size: 1.125rem;
			line-height: 1.75rem;
			list-style: decimal inside;
			margin-bottom: 1rem;
		}
		& .mat-headline {
			font-size: 2.25rem;
		}
		& .mat-subheading {
			font-size: 1.5rem;
		}
		& .mat-subheading-2 {
			font-size: 1.25rem;
		}
		& a {
			&:hover {
				text-decoration: underline;
			}
			color: theme(colors.primary.600);
		}
	}
</style>
